import { createFileRoute } from "@tanstack/react-router";
import { UserDetailPage } from "@/features/users/user-detail-page";

export const Route = createFileRoute("/_authenticated/users/$userId")({
  head: () => ({ meta: [{ title: "User · Rogue Admin" }] }),
  component: UserDetailPage,
});
